import { alertAnatomy as parts } from "@chakra-ui/anatomy"
import type {
  PartsStyleObject,
} from "@chakra-ui/theme-tools"

import { sizes } from '../foundations/sizes'


const baseStyle: PartsStyleObject<typeof parts> = {
  container: {
    // borderRadius: sizes['2']
  },
}

export const Alert = {
  parts: parts.keys,
  baseStyle,
}